export const isPDFFile = (fileType: string): boolean => fileType === 'application/pdf';

export const isImageFile = (fileType: string): boolean => fileType.startsWith('image');

export const areFilesEqual = (fileA: File, fileB: File): boolean =>
  fileA.name === fileB.name && fileA.type === fileB.type;

export const truncateFileName = (fileName: string, maxLength: number = 30): string => {
  // Split the filename into base name and extension
  const parts = fileName.split('.');
  const extension = parts.length > 1 ? parts.pop() : '';
  const baseName = parts.join('.');

  // Handle cases where no truncation is needed
  if (baseName.length <= maxLength) {
    return extension ? `${baseName}.${extension}` : baseName;
  }

  // Handle truncation with ellipsis
  const truncatedBase = baseName.slice(0, maxLength);
  return `${truncatedBase}...${extension}`;
};
